import React, { createContext, useContext, useState } from "react";

const CollapsibleContext = createContext(null);

export function Collapsible({ open: controlledOpen, onOpenChange, children }) {
	const [internalOpen, setInternalOpen] = useState(false);
	const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
	const setOpen = onOpenChange || setInternalOpen;

	return (
		<CollapsibleContext.Provider value={{ open, setOpen }}>
			<div>{children}</div>
		</CollapsibleContext.Provider>
	);
}

export function CollapsibleTrigger({ className = "", children }) {
	const ctx = useContext(CollapsibleContext);
	if (!ctx) throw new Error("CollapsibleTrigger must be used within Collapsible");

	return (
		<button
			type="button"
			className={`grader-collapsible__trigger ${className}`.trim()}
			onClick={() => ctx.setOpen(!ctx.open)}
		>
			{children}
		</button>
	);
}

export function CollapsibleContent({ children }) {
	const ctx = useContext(CollapsibleContext);
	if (!ctx) throw new Error("CollapsibleContent must be used within Collapsible");
	if (!ctx.open) return null;
	return <div className="grader-collapsible__content">{children}</div>;
}
